import Collapsible from "app/components/Collapsible/Collapsible";
import LoadingSpinner from "app/components/LoadingSpinner/LoadingSpinner";
import { EventHelper } from "app/helpers/eventHelper";
import type { EventType } from "app/types/eventType";
import { SportsNameType } from "app/utils/const";
import React, { Suspense, useState } from "react";
import { FormattedMessage } from "react-intl";
import PopularEventCellLabel from "../PopularEventCellLabel/PopularEventCellLabel";
import PopularEventCellMarketsLoading from "../PopularEventCellMarketsLoading/PopularEventCellMarketsLoading";
const EventCellStateDesktop: React.LazyExoticComponent<any> = React.lazy(
  () =>
    import(
      "../../../EventCell/components/EventCellStateDesktop/EventCellStateDesktop"
    )
);
const AlternativeLinesMarketPeriod: React.LazyExoticComponent<any> = React.lazy(
  () =>
    import("../../../AlternativeLinesMarketPeriod/AlternativeLinesMarketPeriod")
);

type Props = {
  data: EventType;
  isEventLoading: boolean;
  statusText: string;
  isEventInExtraTime: boolean;
  scoreFullTime: any;
  isBeforeExtraTime: boolean;
  isFavourite: boolean;
  side: string;
  eventIncidents: any;
  DangerZoneTextOnly: any;
  toggleAddRemoveToFavorites: (...args: Array<any>) => any;
  numberOfMarkets: number;
  toggleAlternativeLines: (...args: Array<any>) => any;
  noOddsMessage: string;
  showAlternativeLines: boolean;
  status: string;
};

const PopularEventCellRow: React.FC<Props> = props => {
  const {
    data,
    isEventLoading,
    statusText,
    isEventInExtraTime,
    scoreFullTime,
    isBeforeExtraTime,
    isFavourite,
    side,
    eventIncidents,
    DangerZoneTextOnly,
    toggleAddRemoveToFavorites,
    numberOfMarkets,
    toggleAlternativeLines,
    noOddsMessage,
    showAlternativeLines,
    status,
  } = props;

  const [isChildHovered, setIsChildHovered] = useState(false);

  const handleChildHover = () => {
    setIsChildHovered(true);
  };

  const handleChildLeave = () => {
    setIsChildHovered(false);
  };

  const isUnavailable = data.marketPeriods == null;
  const parentClassName =
    isChildHovered && !isUnavailable
      ? "popular-event-cell Euro_highlights"
      : isUnavailable
      ? "popular-event-cell popular-event-cell__label unavailable"
      : "popular-event-cell";

  const isCricketEvent = React.useMemo(
    () => data.sportType === SportsNameType.CRICKET,
    [data.sportType]
  );
  const isEventLive = React.useMemo(
    () => EventHelper.isEventLive(data),
    [data.allowLiveBetting, data.inRunning]
  );

  return (
    <Collapsible
      status={status}
      suspended={<div className="suspended__text--event">{statusText}</div>}
      header={
        <div className={parentClassName} id={data.id}>
          {statusText.length > 0 && (
            <div className="suspended__text--event">{statusText}</div>
          )}
          <Suspense
            fallback={
              <div className="fallback">
                <LoadingSpinner />
              </div>
            }
          >
            {isCricketEvent && isEventLive ? (
              <div className="popular-event-cell-state popular-event-cell-state--live-phase">
                <FormattedMessage tagName="span" id="events-dashboard-live" />
              </div>
            ) : (
              <EventCellStateDesktop data={data} />
            )}
          </Suspense>
          {/* Event name and icons */}
          <PopularEventCellLabel
            data={data}
            toggleAddRemoveToFavorites={toggleAddRemoveToFavorites}
            isEventInExtraTime={isEventInExtraTime}
            scoreFullTime={scoreFullTime}
            isBeforeExtraTime={isBeforeExtraTime}
            isFavourite={isFavourite}
            side={side}
            eventIncidents={eventIncidents}
            DangerZoneTextOnly={DangerZoneTextOnly}
            toggleAlternativeLines={toggleAlternativeLines}
            isEventLoading={isEventLoading}
            numberOfMarkets={numberOfMarkets}
            noOddsMessage={noOddsMessage}
            isChildHovered={isChildHovered}
            handleChildHover={handleChildHover}
            handleChildLeave={handleChildLeave}
          />
        </div>
      }
      content={
        <div>
          {isEventLoading ? (
            <PopularEventCellMarketsLoading />
          ) : (
            <div className="popular-event-cell__markets--alternative">
              {data != null &&
                data.alternativeMarketPeriods != null &&
                data.alternativeMarketPeriods.map((marketPeriod, index) => (
                  <Suspense
                    key={`key-${index}`}
                    fallback={<div className="fallback">loading...</div>}
                  >
                    <AlternativeLinesMarketPeriod
                      marketPeriod={marketPeriod}
                      event={props.data}
                      key={index}
                    />
                  </Suspense>
                ))}
            </div>
          )}
        </div>
      }
      isActive={showAlternativeLines}
    />
  );
};

export default PopularEventCellRow;
